import { i18n as _i18n } from "@lingui/core";
import { useLingui } from '@lingui/react';
import { BannerReturnCustomer, CarleadLayout } from '@wkda/carlead-creation-components';
import { Helmet } from 'react-helmet';
import CarleadCollapseButtonFaq from '../../../../components/carlead/CarleadCollapseButton';
import { CarleadHowItWorks } from '../../../../components/shared/HowItWorks';
import CarleadTextButton from '../../../../components/carlead/CarleadTextButton';
import CarleadWhyChoose from '../../../../components/carlead/CarleadWhyChoose';
import TrustPilot from '../../../../components/appointment/TrustPilot';
import { CarleadCrossPromoBannerAH } from '../../../../components/carlead/CarleadCrossPromoBannerAH';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const CarleadHIWWhyChooseWkdaFaq = ({
  form,
  howItWorksShowCta = false,
  showCrossPromoBanner = true,
  withLayout = true,
  showTrustPilot = false
}) => {
  const {
    i18n
  } = useLingui();
  const sections = /*#__PURE__*/_jsxs(_Fragment, {
    children: [showTrustPilot && /*#__PURE__*/_jsx("div", {
      className: "box gap white",
      children: /*#__PURE__*/_jsxs("section", {
        className: "trust-box",
        children: [/*#__PURE__*/_jsx("div", {
          className: "d-none d-lg-block",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "desktop"
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "d-block d-lg-none",
          children: /*#__PURE__*/_jsx(TrustPilot, {
            type: "lead",
            screen: "mobile"
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CarleadHowItWorks, {
      showCTA: howItWorksShowCta
    }), /*#__PURE__*/_jsx(CarleadWhyChoose, {}), /*#__PURE__*/_jsx(CarleadCollapseButtonFaq, {}), /*#__PURE__*/_jsx(CarleadTextButton, {
      text: _i18n._(
      /*i18n*/
      {
        id: 'carlead.textButton.text'
      })
    }), showCrossPromoBanner && /*#__PURE__*/_jsx(CarleadCrossPromoBannerAH, {})]
  });
  if (!withLayout) return sections;
  return /*#__PURE__*/_jsxs(CarleadLayout, {
    customBanner: BannerReturnCustomer,
    containerClassName: "carlead-redesign",
    modernLayout: true,
    children: [/*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: i18n._('carlead.pageTitle')
      })
    }), /*#__PURE__*/_jsxs("div", {
      "data-category": "Lead Page",
      children: [form, sections]
    })]
  });
};
export default CarleadHIWWhyChooseWkdaFaq;